module.exports = __webpack_public_path__ + "img/bsre.00999321.png";